export const DEFAULT_COLUMN_COUNT = 3;
export const DEFAULT_COLUMN_SPAN = 1;
